// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  empresa: 'GESPRON',
  urlImagen: 'assets/empresa/',
  urlUpload: 'https://files.gespronapolo.com',
  urlApi: 'https://slim.gespronapolo.com/slim/public',
  //urlApi: 'https://slim.gespronapolo.com/slimtest/public',
  urlTest: 'https://test.gespronapolo.com',
  urlWeb: 'localhost:4200',
  urlImagenesCanon: 'https://test.gespronapolo.com/imagenes_canon/',
  whatsApp: '',
};
